import { Component } from '@angular/core';
import { Toast } from '../../models/toast.model';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('200ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class ToastComponent {
  toasts: Toast[] = [];

  trackByToastId(index: number, toast: Toast): string {
    return toast.id;
  }

  removeToast(id: string): void {
    this.toasts = this.toasts.filter(t => t.id !== id);
  }

  addToast(toast: Toast): void {
    this.toasts.push(toast);

    if (!toast.persistent) {
      setTimeout(() => {
        this.removeToast(toast.id);
      }, toast.duration || 2000);
    }
  }

  getGlobalToastClasses(type: Toast['type']): string {
    return '';
  }


  getIconClasses(type: Toast['type']): string {
    const baseClasses = 'w-6 h-6 rounded-full flex items-center justify-center';

    switch (type) {
      case 'success':
        return `${baseClasses} bg-brand-primary text-gray-900`;
      case 'error':
        return `${baseClasses} bg-gray-900 dark:bg-dark-text text-white dark:text-danger`;
      case 'warning':
        return `${baseClasses} bg-yellow-500 text-white`;
      case 'info':
        return `${baseClasses} bg-blue-500 text-white`;
      default:
        return baseClasses;
    }
  }

  getTextClasses(type: Toast['type']): string {
    switch (type) {
      case 'success':
        return 'text-gray-900 dark:text-dark-text';
      case 'error':
        return 'text-gray-900 dark:text-dark-text';
      case 'warning':
        return 'text-yellow-900 dark:text-yellow-100';
      case 'info':
        return 'text-blue-900 dark:text-blue-100';
      default:
        return 'text-gray-900 dark:text-dark-text';
    }
  }

  getCloseButtonClasses(type: Toast['type']): string {
    switch (type) {
      case 'success':
        return 'text-gray-400';
      case 'error':
        return 'text-white';
      case 'warning':
        return 'text-yellow-600';
      case 'info':
        return 'text-blue-600';
      default:
        return 'text-gray-400';
    }
  }
}